import { useRouter } from 'next/router';
import { useContext } from 'react';
import { RecentHistory } from 'src/layouts/components/panels/recenthistory/RecentHistoryPanel';
import { PathToTitle, VigoPageContext } from '../context/vigoPageContext';
import { useAppSelector } from 'src/store/baseHooks';
import { safeJsonParse } from '../utils/safeJsonParse';

/**
 * For adding recent history entries
 */
export const useRecentHistory = () => {
  const headerComponentTitles = useAppSelector(state => state.uiflow.flowTitlesState.headerComponentTitles);
  const { pathToTitleMap } = useContext(VigoPageContext);
  const router = useRouter();

  function getIcon(url: string): string {
    try {
      for (let index = 0; index < pathToTitleMap.length; index++) {
        const element: PathToTitle = pathToTitleMap[index];
        const menuItemUiFlowId = element.path.substring(element.path.indexOf('id='));

        if (url.includes(menuItemUiFlowId)) {
          // @ts-ignore
          return element.icon;
        }
      }

      return 'AccountCircleOutline';
    } catch (error) {
      return 'AccountCircleOutline';
    }
  }

  const addRecentHistory = (type: 'Add' | 'Edit', recordName: string) => {
    const oidcStorage = sessionStorage.getItem(
      'oidc.user:' + process.env.NEXT_PUBLIC_AUTHORITY + ':' + process.env.NEXT_PUBLIC_CLIENTID
    );

    let userId = '';
    if (oidcStorage) {
      userId = JSON.parse(oidcStorage).profile.tenantUserId;
    }

    const currentHistory: RecentHistory[] =
      safeJsonParse<RecentHistory[]>(window.localStorage.getItem(`recent-history-${userId}`)) ?? [];
    const currentDate = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    // check if already existing record - keep newest entry
    const existingRecord = currentHistory.find(x => x.record == recordName);
    if (existingRecord) {
      currentHistory.splice(currentHistory.indexOf(existingRecord), 1);
    }

    const recentHistoryNavigationModel: RecentHistory = {
      type: type,
      uiflowName: headerComponentTitles.main,
      record: recordName,
      toPath: router.asPath,
      timeOfChange: currentDate,
      expiry: new Date(tomorrow),
      icon: getIcon(router.asPath)
    };

    currentHistory.unshift(recentHistoryNavigationModel);

    window.localStorage.setItem(`recent-history-${userId}`, JSON.stringify(currentHistory));
  };

  return { addRecentHistory };
};
